import * as constants from './constants';

const INITIAL_STATE = {
  queueAccessoriesCount: 0,
  queueNCLCount: 0,
  queueNCPCount: 0,
  queuePromoCount: 0,
  queueCouponServiceCount: 0,
  queuePackageServiceCount: 0,
  queueCartCount: 0,
  queueGlobalCount: 0,
  queueProductKnowledgeCount: 0,
  queueGamificationCount: 0,
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Accessories
    case constants.ADD_QUEUE_ACCESSORIES_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueAccessoriesCount: state.queueAccessoriesCount + 1,
      };
    case constants.RESET_QUEUE_ACCESSORIES_COUNT:
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueAccessoriesCount: 0,
      };

    // New Car List
    case constants.ADD_QUEUE_NCL_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueNCLCount: state.queueNCLCount + 1,
      };
    case constants.RESET_QUEUE_NCL_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueNCLCount: 0,
      };
    }

    // New Car Purchase
    case constants.ADD_QUEUE_NCP_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueNCPCount: state.queueNCPCount + 1,
      };
    case constants.RESET_QUEUE_NCP_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueNCPCount: 0,
      };
    }

    // Promo
    case constants.ADD_QUEUE_PROMO_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queuePromoCount: state.queuePromoCount + 1,
      };
    case constants.RESET_QUEUE_PROMO_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queuePromoCount: 0,
      };
    }

    // Coupon Service
    case constants.ADD_QUEUE_COUPON_SERVICE_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueCouponServiceCount: state.queueCouponServiceCount + 1,
      };
    case constants.RESET_QUEUE_COUPON_SERVICE_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueCouponServiceCount: 0,
      };
    }

    // Package Service
    case constants.ADD_QUEUE_PACKAGE_SERVICE_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queuePackageServiceCount: state.queuePackageServiceCount + 1,
      };
    case constants.RESET_QUEUE_PACKAGE_SERVICE_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queuePackageServiceCount: 0,
      };
    }

    // Cart
    case constants.ADD_QUEUE_CART_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueCartCount: state.queueCartCount + 1,
      };
    case constants.RESET_QUEUE_CART_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueCartCount: 0,
      };
    }

    // Global
    case constants.ADD_QUEUE_GLOBAL_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueGlobalCount: state.queueGlobalCount + 1,
      };
    case constants.RESET_QUEUE_GLOBAL_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueGlobalCount: 0,
      };
    }

    // Product Knowledge
    case constants.ADD_QUEUE_PRODUCT_KNOWLEDGE_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueProductKnowledgeCount: state.queueProductKnowledgeCount + 1,
      };
    case constants.RESET_QUEUE_PRODUCT_KNOWLEDGE_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueProductKnowledgeCount: 0,
      };
    }

    // Gamification
    case constants.ADD_QUEUE_GAMIFICATION_COUNT:
      sessionStorage.setItem('push_go', '1');
      return {
        ...state,
        queueGamificationCount: state.queueGamificationCount + 1,
      };
    case constants.RESET_QUEUE_GAMIFICATION_COUNT: {
      sessionStorage.removeItem('push_go');
      return {
        ...state,
        queueGamificationCount: 0,
      };
    }

    default:
      return state;
  }
};

export default exportedObject;
